import { TextSizeGroup } from './TextSizeGroup';
import { runtime } from '../../runtime/Runtime';
export class GlobalTextSizer {
    parent;
    textSizeGroups = new Map();
    constructor(parent) {
        this.parent = parent;
    }
    get app() {
        return this.parent.app;
    }
    get isMasterSizer() {
        return (runtime.runtimePermissions.hasEditPermissions &&
            runtime.solidBrowserRuntime.app.stage.stageInnerMeasure.stageWidthInPixel > 600);
    }
    getTextSizeGroup(groupName) {
        if (!this.textSizeGroups.get(groupName)) {
            this.textSizeGroups.set(groupName, new TextSizeGroup({ groupName, parent: this }));
        }
        return this.textSizeGroups.get(groupName);
    }
}
